import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { MyRequestSharedComponent } from '../../shared/components/my-request-shared/my-request-shared.component';
import { GrantedAccessPanelComponent } from '../../shared/components/granted-access-panel/granted-access-panel.component';
import { ConsumerAssetFeedbackComponent } from '../asset-feedback/asset-feedback.component';
import { WorkspaceContextService } from '../../services/workspace-context.service';

@Component({
  selector: 'app-my-request',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    MyRequestSharedComponent,
    GrantedAccessPanelComponent,
    ConsumerAssetFeedbackComponent,
  ],
  templateUrl: './my-request.component.html',
  styleUrl: './my-request.component.scss',
})
export class MyRequestComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly workspaceContext = inject(WorkspaceContextService);

  activeTab: 'myRequests' | 'createdPolicies' | 'assetFeedback' = 'myRequests';

  get showMyRequestsTab(): boolean {
    return !this.workspaceContext.isDelegateSession();
  }

  /** Delegates cannot open the user-rating flow. */
  get showAssetFeedbackTab(): boolean {
    return !this.workspaceContext.isDelegateSession();
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const tabFromUrl = params.get('tab');
      if (!this.showMyRequestsTab) {
        this.activeTab = 'createdPolicies';
        return;
      }
      if (
        tabFromUrl === 'myRequests' ||
        tabFromUrl === 'createdPolicies' ||
        (tabFromUrl === 'assetFeedback' && this.showAssetFeedbackTab)
      ) {
        this.activeTab = tabFromUrl;
      }
    });
  }

  setActiveTab(tab: 'myRequests' | 'createdPolicies' | 'assetFeedback'): void {
    if (tab === 'assetFeedback' && !this.showAssetFeedbackTab) {
      return;
    }
    this.activeTab = tab;
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
